<project-placement-picker
  [inputProject]="this.inputProject"
  [inputSubProject]="this.inputSubProject"
  [inputProjectPlacement]="this.inputSubProject.projectPlacement"
  [client]="client"
  [fromOldSystem]="fromOldSystem"
  [disabled]="disabled"
  (outputProject)="emit()"
  (higherFloorOptionSelected)="higherFloorOptionSelected.emit($event)"
></project-placement-picker>
<div *ngIf="!client && !fromOldSystem && !projectHasIPBoard">
  <mat-card
    *ngIf="
      inputSubProject.withPlacement && inputSubProject.projectPlacement != null
    "
    class="internal-form mat-elevation-z0 card-bottom-space"
  >
    <textarea-input
      [placeholder]="''"
      [initContent]="
        inputSubProject.projectPlacement.locationVerificationExtraInfo
      "
      (answer)="setLocationVerificationExtraInfo($event)"
    >
    </textarea-input>
    <checkbox
      [text]="'Locatiebepaling volledig in orde'"
      [checked]="
        inputSubProject.projectPlacement.locationVerificationCheckedByExpert
      "
      (answer)="setLocationVerificationCheckedByExpert($event)"
    ></checkbox>
    <logged-action-display
      *ngIf="
        inputSubProject.projectPlacement
          .locationVerificationCheckedByExpertRegistration != null
      "
      [inputLoggedAction]="
        inputSubProject.projectPlacement
          .locationVerificationCheckedByExpertRegistration
      "
    ></logged-action-display>
  </mat-card>
  <product-placement-picker
    *ngFor="let product of inputProject?.products; let index = index"
    [inputProject]="this.inputSubProject"
    [inputProduct]="product"
    [index]="index"
    [isCollapsed]="isCollapsed"
    (outputProduct)="productPlacementPickerAnswered()"
  >
  </product-placement-picker>
</div>
